import utils from '@/utils'
const { loadable } = utils;

const Index = loadable(() => import(/* webpackChunkName: 'index' */ '@/views/Index'))


// 其它
const UploadView = loadable(() => import(/* webpackChunkName: 'upload' */ '@/views/Others/Upload'))

const TestView = loadable(() => import(/* webpackChunkName: 'TestView' */ '@/views/TestView'))


const Admin = loadable(() => import(/* webpackChunkName: 'user' */ '@/views/Admin'))
const AdminCreate = loadable(() => import(/* webpackChunkName: 'userEdit' */ '@/views/Admin/AdminCreate'))
const AdminEdit = loadable(() => import(/* webpackChunkName: 'userEdit' */ '@/views/Admin/AdminEdit'))
const AdminChangePassword = loadable(() => import(/* webpackChunkName: 'userEdit' */ '@/views/Admin/AdminChangePassword'))

const User = loadable(() => import(/* webpackChunkName: 'user' */ '@/views/User'))
const UserEdit = loadable(() => import(/* webpackChunkName: 'userEdit' */ '@/views/User/UserEdit'))

const QuickTask = loadable(() => import(/* webpackChunkName: 'QuickTask' */ '@/views/QuickTask'))
const QuickTaskEdit = loadable(() => import(/* webpackChunkName: 'QuickTaskEdit' */ '@/views/QuickTask/QuickTaskEdit'))

const Task = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/Task'))
const TaskEdit = loadable(() => import(/* webpackChunkName: 'TaskEdit' */ '@/views/Task/TaskEdit'))

const Order = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/Order'))
const OrderEdit = loadable(() => import(/* webpackChunkName: 'TaskEdit' */ '@/views/Order/OrderEdit'))

const PaymentLog = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/PaymentLog'))

const VipCard = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/VipCard'))
const VipCardEdit = loadable(() => import(/* webpackChunkName: 'TaskEdit' */ '@/views/VipCard/VipCardEdit'))

const PointCard = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/PointCard'))
const PointCardEdit = loadable(() => import(/* webpackChunkName: 'TaskEdit' */ '@/views/PointCard/PointCardEdit'))

const Setting = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/Setting'))
const SettingEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/Setting/SettingEdit'))

const MemberLevelConfig = loadable(() => import(/* webpackChunkName: 'MemberLevelConfig' */ '@/views/MemberLevelConfig'))
const MemberLevelConfigEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/MemberLevelConfig/MemberLevelConfigEdit'))

const Label = loadable(() => import(/* webpackChunkName: 'Label' */ '@/views/Label'))
const LabelEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/Label/LabelEdit'))

const ModelCategory = loadable(() => import(/* webpackChunkName: 'Label' */ '@/views/ModelCategory'))
const ModelCategoryEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/ModelCategory/ModelCategoryEdit'))

const ModelName = loadable(() => import(/* webpackChunkName: 'Label' */ '@/views/ModelName'))
const ModelNameEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/ModelName/ModelNameEdit'))

const ModelPicture = loadable(() => import(/* webpackChunkName: 'Label' */ '@/views/ModelPicture'))
const ModelPictureEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/ModelPicture/ModelPictureEdit'))

const routes = [
    { path: '/index', exact: true, name: 'Index', component: Index, auth: [1] },

    // { path: '/others/upload', exact: false, name: '上传', component: UploadView, auth: [1] },
    // { path: '/one/two/three', exact: false, name: '三级', component: Three },

    { path: '/admin', exact: false, name: '管理员', component: Admin, auth: [1] },
    { path: '/admin/adminCreate', exact: false, name: '管理员新增', component: AdminCreate, auth: [1] },
    { path: '/admin/adminEdit', exact: false, name: '管理员编辑', component: AdminEdit, auth: [1] },
    { path: '/admin/changePassword', exact: false, name: '修改密码', component: AdminChangePassword, auth: [1] },

    { path: '/user', exact: false, name: '用户', component: User, auth: [1] },
    { path: '/user/userEdit', exact: false, name: '用户', component: UserEdit, auth: [1] },

    { path: '/quickTask', exact: false, name: '快捷任务', component: QuickTask, auth: [1] },
    { path: '/quickTask/quickTaskEdit', exact: false, name: '快捷任务', component: QuickTaskEdit, auth: [1] },

    { path: '/task', exact: false, name: '任务', component: Task, auth: [1] },
    { path: '/task/taskEdit', exact: false, name: '任务', component: TaskEdit, auth: [1] },

    { path: '/order', exact: false, name: '订单', component: Order, auth: [1] },
    { path: '/order/orderEdit', exact: false, name: '订单', component: OrderEdit, auth: [1] },

    { path: '/VipCard', exact: false, name: '积分卡', component: VipCard, auth: [1] },
    { path: '/VipCard/edit', exact: false, name: '积分卡', component: VipCardEdit, auth: [1] },

    { path: '/pointCard', exact: false, name: '积分卡', component: PointCard, auth: [1] },
    { path: '/pointCard/edit', exact: false, name: '积分卡', component: PointCardEdit, auth: [1] },

    { path: '/PaymentLog', exact: false, name: '支付记录', component: PaymentLog, auth: [1] },

    { path: '/setting', exact: false, name: '设置', component: Setting, auth: [1] },
    { path: '/setting/edit', exact: false, name: '设置', component: SettingEdit, auth: [1] },

    { path: '/MemberLevelConfig', exact: false, name: '用户等级', component: MemberLevelConfig, auth: [1] },
    { path: '/MemberLevelConfig/edit', exact: false, name: '用户等级', component: MemberLevelConfigEdit, auth: [1] },

    { path: '/label', exact: false, name: '分类', component: Label, auth: [1] },
    { path: '/label/edit', exact: false, name: '分类', component: LabelEdit, auth: [1] },

    { path: '/modelCategory', exact: false, name: '模特类型', component: ModelCategory, auth: [1] },
    { path: '/modelCategory/edit', exact: false, name: '模特类型', component: ModelCategoryEdit, auth: [1] },

    { path: '/modelName', exact: false, name: '模特名字', component: ModelName, auth: [1] },
    { path: '/modelName/edit', exact: false, name: '模特名字', component: ModelNameEdit, auth: [1] },

    { path: '/modelPicture', exact: false, name: '模特图片', component: ModelPicture, auth: [1] },
    { path: '/modelPicture/edit', exact: false, name: '模特图片', component: ModelPictureEdit, auth: [1] },

    { path: '/test', exact: false, name: '测试', component: TestView, auth: [1] },
]

export default routes
